import { FETCH_ANNOUNCEMENTS_SUCCESS, FETCH_ANNOUNCEMENTS_FAILURE } from '../types';

export default function announcements(state = [], action) {
	switch (action.type) {
		case FETCH_ANNOUNCEMENTS_SUCCESS:
			return [ ...action.payload ];
		case FETCH_ANNOUNCEMENTS_FAILURE:
			return [];
		default:
			return state;
	}
}

export const getAnnouncements = (state) => state;
